// frontend/src/context/Socket/socketOptions.js
//
// Shared Socket.IO client options. The JWT travels in the handshake `auth`
// payload (never in the connection URL) and polling stays as a downgrade path
// when the WebSocket upgrade fails.

export const buildSocketOptions = (token) => ({
  transports: ["websocket", "polling"],
  pingTimeout: 18000,
  pingInterval: 18000,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 8000,
  auth: { token },
});
